/**
 * Utilitário para rastreamento de eventos do Google Analytics
 */

/**
 * Envia um evento para o Google Analytics
 * @param {string} eventName - Nome do evento
 * @param {object} params - Parâmetros do evento
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params)
  } else {
    // Fallback para desenvolvimento
    console.log('📊 GA Event:', eventName, params)
  }
}

/**
 * Rastreia cliques em CTAs da Escola de Crescimento
 * @param {string} location - Localização do CTA (ex: 'banner_hero', 'jornada_section', 'sticky_cta')
 * @param {string} ctaText - Texto do botão clicado
 */
export const trackEscolaCTAClick = (location, ctaText) => {
  trackEvent('escola_cta_click', {
    location,
    cta_text: ctaText,
    timestamp: new Date().toISOString()
  })
}

/**
 * Rastreia quando uma aula é iniciada
 * @param {number} lessonId - ID da aula
 * @param {string} lessonTitle - Título da aula
 * @param {string} format - Formato (audio ou pdf)
 */
export const trackLessonStarted = (lessonId, lessonTitle, format) => {
  trackEvent('aula_started', {
    lesson_id: lessonId,
    lesson_title: lessonTitle,
    format,
    timestamp: new Date().toISOString()
  })
}

/**
 * Rastreia quando uma aula é completada
 * @param {number} lessonId - ID da aula
 * @param {string} lessonTitle - Título da aula
 * @param {number} totalCompleted - Total de aulas completadas até agora
 */
export const trackLessonCompleted = (lessonId, lessonTitle, totalCompleted) => {
  trackEvent('aula_completed', {
    lesson_id: lessonId,
    lesson_title: lessonTitle,
    total_completed: totalCompleted,
    timestamp: new Date().toISOString()
  })
}

/**
 * Rastreia download de PDF
 * @param {number} lessonId - ID da aula
 * @param {string} lessonTitle - Título da aula
 * @param {string} pdfUrl - URL do PDF
 */
export const trackPDFDownload = (lessonId, lessonTitle, pdfUrl) => {
  trackEvent('pdf_download', {
    lesson_id: lessonId,
    lesson_title: lessonTitle,
    pdf_url: pdfUrl,
    timestamp: new Date().toISOString()
  })
}

/**
 * Rastreia play de áudio
 * @param {number} lessonId - ID da aula
 * @param {string} lessonTitle - Título da aula
 */
export const trackAudioPlay = (lessonId, lessonTitle) => {
  trackEvent('audio_play', {
    lesson_id: lessonId,
    lesson_title: lessonTitle,
    timestamp: new Date().toISOString()
  })
}

/**
 * Rastreia navegação para a página da Escola
 * @param {string} source - Origem da navegação
 */
export const trackEscolaPageView = (source) => {
  trackEvent('escola_page_view', {
    source,
    timestamp: new Date().toISOString()
  })
}
